import ResetCursor from "./ResetCursor";

const LoadingAction = (
  setLoading,
  callback,
  delay = 1500
) => {
  setLoading(true);

  setTimeout(() => {
    ResetCursor();

    if (callback) {
      callback();
    }

    setLoading(false);
  }, delay);
};

export default LoadingAction;